module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Kandidaten":"The candidate","har skrivit till er i jobbet":"has written to you on the job"},"sv":{"Kandidaten":"Kandidaten","har skrivit till er i jobbet":"har skrivit till er i jobbet"}}')
  delete Component.options._Ctor
}
